const routes = [
  {
    path: '',
    component: () =>
      import('@/views/provider/specialist-availability-calendar/Wrapper.vue'),
    children: [
      {
        path: '/provider/specialist-availability-calendar/:admissionId?',
        name: 'SpecialistAvailabilityCalendar',
        component: () =>
          import('@/views/provider/specialist-availability-calendar/Main.vue'),
      },
      {
        path:
          '/provider/specialist-availability-calendar/:edit/:admissionId/:specialistId/:scheduleId/:id',
        name: 'SpecialistAvailabilityCalendarEdit',
        component: () =>
          import('@/views/provider/specialist-availability-calendar/Main.vue'),
      },
      {
        path:
          '/provider/specialist-availability-calendar/:admissionId/:isTransfer/false',
        name: 'SpecialistAvailabilityCalendarTransfer',
        component: () =>
          import('@/views/provider/specialist-availability-calendar/Main.vue'),
      },
      {
        path:
          '/provider/specialist-availability-calendar/:admissionId/false/:isCoordination',
        name: 'SpecialistAvailabilityCalendarCoordination',
        component: () =>
          import('@/views/provider/specialist-availability-calendar/Main.vue'),
      },
    ],
  },
];

export default routes;
